
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Mehr als die Hälfte starb in Alters- und Pflegeheimen`}</h1>
    <h2>{`Gemäss einer Recherche bei den Kantonen ereignete sich von 1753 Covid-19-Todesfällen in der Schweiz der grösste Teil in Alters- und Pflegeheimen. Hat man die verwundbarsten Personen zu wenig geschützt?`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;